import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FloatLabelType } from '@angular/material/form-field';

/* Loan product type filter: standard loans or asset finance. The value is the
   loan product's productCategory, which list endpoints filter on; '' is All,
   and a page should leave productCategory out of its request then. */
@Component({
  selector: 'app-product-category-search-select',
  templateUrl: './product-category-search-select.component.html',
})
export class ProductCategorySearchSelectComponent {
  @Input() control: FormControl | string;
  // false where a type must always be picked (the bulk posting pages)
  @Input() showAll = true;
  @Output() emitSelectedVal: EventEmitter<string> = new EventEmitter();
  // float the label on mobile so it isn't clipped by the compact field height
  public floatLabel: FloatLabelType = 'auto';

  public readonly categories = [
    { label: $localize`:@@loans:Loans`, value: 'STANDARD' },
    { label: $localize`:@@asset_finance:Asset Finance`, value: 'ASSET_FINANCING' },
  ];

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe('(max-width: 499.98px)')
      .subscribe((res) => (this.floatLabel = res.matches ? 'always' : 'auto'));
  }

  public categoryChange(value: string) {
    this.emitSelectedVal.emit(value || '');
  }

  public get ctrl() {
    return this.control as FormControl;
  }
}
